/*!

=========================================================
* Material Kit React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
// nodejs library to set properties for components
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
import Dashboard from '@material-ui/icons/Dashboard';
import Schedule from '@material-ui/icons/Schedule';
import List from '@material-ui/icons/List';

// core components
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import NavPills from '../../../components/NavPills/NavPills';

import pillsStyle from '../../../assets/jss/material-kit-react/views/componentsSections/pillsStyle';
import { WithStyles } from '@material-ui/styles';

type ISectionPillsProps = WithStyles<typeof pillsStyle>;

class SectionPills extends React.Component<ISectionPillsProps> {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <div id="navigation-pills">
            <div className={classes.title}>
              <h3>Navigation Pills</h3>
            </div>
            <div className={classes.title}>
              <h3>
                <small>With Icons</small>
              </h3>
            </div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8} lg={6}>
                <NavPills
                  color="primary"
                  active={0}
                  tabs={[
                    {
                      tabButton: 'Dashboard',
                      tabIcon: Dashboard,
                      tabContent: (
                        <span>
                          <p>
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                        </span>
                      ),
                    },
                    {
                      tabButton: 'Schedule',
                      tabIcon: Schedule,
                      tabContent: (
                        <span>
                          <p>
                            Efficiently unleash cross-media information without cross-media value. Quickly maximize
                            timely deliverables for real-time schemas.
                          </p>
                          <br />
                          <p>
                            Dramatically maintain clicks-and-mortar solutions without functional solutions. Dramatically
                            visualize customer directed convergence without revolutionary ROI. Collaboratively
                            administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C
                            users after installed base benefits.
                          </p>
                        </span>
                      ),
                    },
                    {
                      tabButton: 'Tasks',
                      tabIcon: List,
                      tabContent: (
                        <span>
                          <p>
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                        </span>
                      ),
                    },
                  ]}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={6}>
                <NavPills
                  color="rose"
                  active={0}
                  horizontal={{
                    tabsGrid: { xs: 12, sm: 4, md: 4 },
                    contentGrid: { xs: 12, sm: 8, md: 8 },
                  }}
                  tabs={[
                    {
                      tabButton: 'Dashboard',
                      tabIcon: Dashboard,
                      tabContent: (
                        <span>
                          <p>
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                          <br />
                          <p>
                            Dramatically visualize customer directed convergence without revolutionary ROI.
                            Collaboratively administrate empowered markets via plug-and-play networks. Dynamically
                            procrastinate B2C users after installed base benefits.
                          </p>
                        </span>
                      ),
                    },
                    {
                      tabButton: 'Schedule',
                      tabIcon: Schedule,
                      tabContent: (
                        <span>
                          <p>
                            Efficiently unleash cross-media information without cross-media value. Quickly maximize
                            timely deliverables for real-time schemas.
                          </p>
                          <br />
                          <p>
                            Dramatically maintain clicks-and-mortar solutions without functional solutions. Dramatically
                            visualize customer directed convergence without revolutionary ROI. Collaboratively
                            administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C
                            users after installed base benefits.
                          </p>
                        </span>
                      ),
                    },
                  ]}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(pillsStyle)(SectionPills);
